import LineRedirect from '@/pages/redirect/line';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(redirect)/line/')({
  component: LineRedirect,
});
